/* COMPONENT IMPORTS*/
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import { Loading } from "../../components/Loading/Loading";
import ContextConstructor from "../../components/Context/Context";
import { LandingPage } from "../../components/HomeNoAssociate/LandingPage";
import { NotAssociateHome } from "../../components/HomeNoAssociate/NotAssociateHome";

import { BaseCardIntegratedPosition } from "../../components/BaseCardIntegratedPosition/BaseCardIntegratedPosition";
import BenefitCard from "../../components/BenefitsCard/BenefitCard";
import BannerCarousel from "../../components/BannerCarousel/BannerCarousel";

/* MODULE IMPORTS */
import { NavLink } from "react-router-dom";
import React, { Component } from "react";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";

/* CSS IMPORT */
import "./Home.css";
import "pure-react-carousel/dist/react-carousel.es.css";

import sendLogError from "../../sendLogError";
import newseriesImg from "../../images/newseries.png";

var reactPlugin = new ReactPlugin();
class Home extends Component {
  static displayName = Home.name;

  constructor(props) {
    super(props);
    this.state = {
      portfolioData: [],
      portfolioCardsData: [],
      benefitData: [],
      error: [],
      loadingB: true,
      loadingP: true,
      failure: false,
      benefits: [],
      totalBenefits: 0,
      benefitsByCategory: [],
      toggleActive: true,
      active: "aTab",
      hasBenefits: false,
      DateString: [],
      DateStringValue: "",
      DateStart: new Date(),
      DateEnd: new Date(),
      DateStartCalendar: new Date(),
      DateEndCalendar: new Date(),
      Sort: "1",
      filtered: [],
      select2: undefined,
      sortSelect: "Maior Poupança",
    };
  }

  componentDidMount() {
    const { selectedUserID } = this.context;

    if (selectedUserID) {
      this.populatePortfolioCardsData();
      this.populateBenefitsByCategoryData();
      // this.populateBenefitsData();
    }

    this.getScrollPositionForCss();
  }

  componentWillUnmount() {
    if (this.abortControllerPortfolio) {
      this.abortControllerPortfolio.abort();
    }

    if (this.abortControllerBenefits) {
      this.abortControllerBenefits.abort();
    }
  }

  getScrollPositionForCss = () => {
    const debounce = (fn) => {
      let frame;
      return (...params) => {
        if (frame) {
          cancelAnimationFrame(frame);
        }
        frame = requestAnimationFrame(() => {
          fn(...params);
        });
      };
    };

    const storeScroll = () => {
      document.documentElement.dataset.scroll = window.scrollY;
    };

    document.addEventListener("scroll", debounce(storeScroll), {
      passive: true,
    });

    storeScroll();
  };

  renderDashboard() {
    return (
      <BaseCardIntegratedPosition
        history={this.props.history}
        incomeSavings={this.state.portfolioCardsData?.savings?.totalAmounts?.totalInvestedAmount}
        gainSavings={this.state.portfolioCardsData?.savings?.totalAmounts?.totalReceivedAmount}
        protectionCurrentAmount={
          this.state.portfolioCardsData?.protection?.totalAmounts?.totalCurrentAmount
        }
        protectionsavingsCurrentAmount={
          this.state.portfolioCardsData?.savingsPlusProtection?.totalAmounts?.totalCurrentAmount
        }
      />
    );
  }

  renderBenefitsDashboard() {
    var content =
      this.state.totalBenefits > 0 ? (
        <BenefitCard
          text="Por ser Associado já poupou"
          value={this.state.totalBenefits}
          onClick={() => {
            this.props.history.push("/beneficios");
          }}
        />
      ) : (
        <BenefitCard
          text="Descubra todos os benefícios que temos para si!"
          value={this.state.totalBenefits}
          onClick={() => {
            window.open(
              "https://www.montepio.org/vantagens-montepio/beneficios-associativos/",
              "_blank",
              "noopener,noreferrer",
            );
          }}
        />
      );

    const pieChart = () => {
      if (this.state.toggleActive)
        return (
          <div>
            <br />
            <br />
            <div className="pie-div-home-title">
              <span className="b-modalidades-title-span">Os meus benefícios</span>
            </div>
            <div className="pie-div pie-div-home">
              {/* {grafico} */}
              <div className="title-benefits">Benefícios</div>
              <NavLink to="/beneficios">
                <img
                  className="plus-icon-orange"
                  src={newseriesImg}
                  to="/beneficios"
                  alt="Botão de subscrever"
                  width="60px"
                  height="60px"></img>
                <div className="detail-benefits">Ver detalhe</div>
              </NavLink>
            </div>
          </div>
        );
    };
    return content;
  }

  NotAssociateHomepage() {
    let entityWithMinors = this.context.mymUsers.length > 1 ? true : false;

    if (entityWithMinors === false) {
      return <LandingPage />;
    } else {
      return <NotAssociateHome />;
    }
  }

  render() {
    const benefitsContent =
      this.state.loadingB || this.context.selectedUserID === "" ? (
        <Loading />
      ) : this.state.error || this.context.selectedUserID === "" ? (
        <ErrorPage />
      ) : (
        this.renderBenefitsDashboard(this.state.benefitData)
      );

    const portfolioContent =
      this.state.loadingP || this.context.selectedUserID === "" ? (
        <Loading />
      ) : this.state.error || this.context.selectedUserID === "" ? (
        <ErrorPage />
      ) : (
        this.renderDashboard(this.state.portfolioData)
      );

    let more =
      (
        <BannerCarousel
          context={this.context}
          visibleItems={3}
          onBannerClick={(banner) => {
            const { url, title, linkType } = banner?.link

            if (linkType === "External") {
              window.open(
                url,
                "_blank",
                "noopener,noreferrer",
              );
            }
          }}
        />
      );

    let content = (
      <body className="main">
        {portfolioContent}
        {benefitsContent}
        {more}
      </body>
    );
    return <React.Fragment>{content}</React.Fragment>;
  }

  async populatePortfolioData() {
    try {
      const { selectedUserID, idToken } = this.context;

      const headers = {
        Authorization: `Bearer ${idToken}`,
        clientId: selectedUserID,
      };

      const response = await fetch("/Portfolio/GetPortfolio", {
        headers,
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const data = await response.json();

      this.setState({
        portfolioData: data,
        error: false,
        loadingP: false,
      });
    } catch (error) {
      console.error("Error fetching portfolio:", error);

      this.setState({
        error: true,
        loadingP: false,
      });

      sendLogError(error.message, "populatePortfolioData");

      if (error.message.includes("204")) {
        console.log("No Content!");
      }
    }
  }

  async populatePortfolioCardsData() {
    try {
      // cancelar anterior
      if (this.abortControllerPortfolio) {
        this.abortControllerPortfolio.abort();
      }

      this.abortControllerPortfolio = new AbortController();

      const { selectedUserID, idToken } = this.context;

      const response = await fetch("/Portfolio/GetPortfolioCards", {
        headers: {
          Authorization: `Bearer ${idToken}`,
          clientId: selectedUserID,
        },
        signal: this.abortControllerPortfolio.signal,
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const data = await response.json();

      this.setState({
        portfolioCardsData: data,
        error: false,
        loadingP: false,
      });
    } catch (error) {
      if (error.name === "AbortError") {
        return;
      }

      console.error("Error fetching portfolio cards:", error);

      this.setState({
        error: true,
        loadingP: false,
      });

      sendLogError(error.message, "populatePortfolioCardsData");
    }
  }

  async populateBenefitsByCategoryData() {
    try {
      // cancelar anterior
      if (this.abortControllerBenefits) {
        this.abortControllerBenefits.abort();
      }

      this.abortControllerBenefits = new AbortController();

      const { selectedUserID, idToken } = this.context;

      const response = await fetch("/Benefits/GetBenefitsByCategory", {
        headers: {
          Authorization: `Bearer ${idToken}`,
          clientId: selectedUserID,
        },
        signal: this.abortControllerBenefits.signal,
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const data = await response.json();

      const totalBenefits = Number(data?.totalBenefits || 0);
      const hasBenefits = totalBenefits > 0;

      this.setState({
        benefitsByCategory: data,
        totalBenefits,
        hasBenefits,
        error: false,
        loadingB: false,
      });
    } catch (error) {
      if (error.name === "AbortError") {
        return;
      }

      console.error("Error fetching benefits by category:", error);

      this.setState({
        error: true,
        loadingB: false,
        hasBenefits: false,
      });

      sendLogError(error.message, "populateBenefitsByCategoryData");

      if (error.message.includes("204")) {
        console.log("Benefits no content");
      }
    }
  }

  async populateBenefitsData() {
    try {
      const { selectedUserID, idToken } = this.context;

      const headers = {
        Authorization: `Bearer ${idToken}`,
        clientId: selectedUserID,
      };

      const response = await fetch("/Benefits/GetBenefits", {
        headers,
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const data = await response.json();

      const benefitsAll = Array.isArray(data?.benefitsAll) ? data.benefitsAll : [];

      let DateString = "";

      if (benefitsAll.length > 0) {
        DateString =
          new Intl.DateTimeFormat("pt-PT").format(new Date(benefitsAll[0].transactionDate)) +
          " - " +
          new Intl.DateTimeFormat("pt-PT").format(new Date());
      }

      const totalBenefits = Number(data?.totalBenefits || 0);
      const hasBenefits = totalBenefits > 0;

      this.setState({
        benefits: data,
        DateString,
        hasBenefits,
        error: false,
        loadingB: false,
      });
    } catch (error) {
      console.error("Error fetching benefits:", error);

      this.setState({
        error: true,
        loadingB: false,
        hasBenefits: false,
      });

      sendLogError(error.message, "populateBenefitsData");

      if (error.message.includes("204")) {
        console.log("No content!");
      }
    }
  }
}

Home.contextType = ContextConstructor;

export default withAITracking(reactPlugin, Home);
